import React, { useState, useEffect } from 'react';
import AdminLayout from '../layouts/AdminLayout';
import '../styles/Admin_Article_Creation.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  fetchTopics,
  fetchLanguages,
  fetchSerialArticles,
  createArticle, // ✅ New API call
} from '../utils/apiCall';

export default function Admin_Article_Creation() {
  const [editorContent, setEditorContent] = useState('');
  const [topics, setTopics] = useState([]);
  const [serialArticles, setSerialArticles] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState('');
  const [selectedSerialArticle, setSelectedSerialArticle] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [isSerialArticle, setIsSerialArticle] = useState(false);
  const [articleName, setArticleName] = useState('');
  const [loading, setLoading] = useState(true);

  // ✅ Load dropdown data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [topicsData, serialData, langData] = await Promise.all([
          fetchTopics(),
          fetchSerialArticles(),
          fetchLanguages(),
        ]);

        setTopics(topicsData);
        setSerialArticles(serialData);
        setLanguages(langData);
      } catch (error) {
        console.error('Error loading dropdown data:', error);
        alert('❌ Failed to load dropdown data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ✅ Handle Save -> call POST /articles
  const handleSave = async () => {
    if (!articleName || !selectedTopic || !selectedLanguage || !editorContent) {
      alert('⚠️ Please fill all required fields!');
      return;
    }

    const payload = {
      articleName: articleName,
      masterTopicUuid: selectedTopic,
      articleContent: editorContent,
      defaultLanguage: selectedLanguage,
      serialArticleUuid: isSerialArticle ? selectedSerialArticle : null,
    };

    try {
      const response = await createArticle(payload);
      console.log('✅ Article created successfully:', response);
      alert('✅ Article created successfully!');

      // Optional: clear the form
      setArticleName('');
      setEditorContent('');
      setSelectedTopic('');
      setSelectedLanguage('');
      setSelectedSerialArticle('');
      setIsSerialArticle(false);
    } catch (error) {
      console.error('❌ Error creating article:', error);
      alert('❌ Failed to create article');
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
      [{ align: [] }],
    ],
  };

  if (loading) {
    return (
      <AdminLayout>
        <div style={{ padding: '2rem' }}>
          <h3>Loading data...</h3>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="related-articles">
        <h2 style={{ marginTop: '1em' }}>Article Creation</h2>

        {/* Article Name */}
        <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          <label>
            <strong>Article Name:</strong>{' '}
            <input
              type="text"
              value={articleName}
              onChange={(e) => setArticleName(e.target.value)}
              placeholder="Enter article title..."
              style={{
                width: '400px',
                marginLeft: '0.5rem',
                padding: '0.3rem',
              }}
            />
          </label>
        </div>

        {/* Metadata fields */}
        <div style={{ marginTop: '1rem', marginBottom: '2rem' }}>
          <label>
            <strong>Topic:</strong>{' '}
            <select
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
            >
              <option value="">-- Select Topic --</option>
              {topics.map((topic) => (
                <option key={topic.topicUuid} value={topic.topicUuid}>
                  {topic.topicName}
                </option>
              ))}
            </select>
          </label>

          <label style={{ marginLeft: '1rem' }}>
            <strong>Language:</strong>{' '}
            <select
              value={selectedLanguage}
              onChange={(e) => setSelectedLanguage(e.target.value)}
            >
              <option value="">-- Select Language --</option>
              {languages.map((lang) => (
                <option key={lang.languageCode} value={lang.languageCode}>
                  {lang.languageName}
                </option>
              ))}
            </select>
          </label>

          <label style={{ marginLeft: '1rem' }}>
            <input
              type="checkbox"
              checked={isSerialArticle}
              onChange={(e) => setIsSerialArticle(e.target.checked)}
              style={{ marginRight: '0.3rem' }}
            />
            Is Serial Article
          </label>

          {isSerialArticle && (
            <label style={{ marginLeft: '1rem' }}>
              <strong>Serial Article:</strong>{' '}
              <select
                value={selectedSerialArticle}
                onChange={(e) => setSelectedSerialArticle(e.target.value)}
              >
                <option value="">-- Select Serial --</option>
                {serialArticles.map((serial) => (
                  <option
                    key={serial.serialArticleUuid}
                    value={serial.serialArticleUuid}
                  >
                    {serial.serialArticleName}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>

        {/* Quill Editor */}
        <div className="editor-wrapper">
          <ReactQuill
            value={editorContent}
            onChange={setEditorContent}
            modules={modules}
            theme="snow"
            placeholder="Write your article here..."
            style={{ height: '100%', minHeight: '300px' }}
          />
        </div>

        {/* Save Button */}
        <div style={{ marginTop: '2rem' }}>
          <button onClick={handleSave}>Save Article</button>
        </div>
      </div>
    </AdminLayout>
  );
}
